<template>
  <div class="job-group">
    <div
      v-for="job in group.jobs"
      class="job-group__jobride d-inline-block"
      style="background-color:#F2F2F2; position: relative; padding: 10px 25px 10px 15px; margin-bottom: 10px;"
    >
      <div class="d-flex">
        <img src='/images/job_statuses/default.svg' style="width: 20px; margin: 0px 10px;">

        <div class="p-left-10">
          <strong v-html="jobRoute(job)"></strong>

          <div class="text-muted" style="font-size:13px;">
            {{ jobTime(job) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobGroup",

  props: {
    group: {
      type: Object,
      required: true,
    },
  },

  methods: {
    jobRoute(job) {
      return job.job_rides.map((jobRide, index) => {
        if (index > 0) {
          return `<span data-copy-click>${jobRide.to_location_city}</span> (${jobRide.to_location_province_short})`
        }

        return `<span data-copy-click>${jobRide.from_location_city}</span> (${jobRide.from_location_province_short}) - <span data-copy-click>${jobRide.to_location_city}</span> (${jobRide.to_location_province_short})`
      }).join(' - ');
    },

    jobTime(job) {
      if (job.time_type_text_abbreviation === 'GT') {
        return `${job.time_type_text}`;
      }

      return `${job.time_type_text_abbreviation} ${job.time_from_text} ${job.time_to_text}`;
    },
  }
}
</script>

<style>
.job-group__jobride:after {
  content: '';
  border: solid #fff;
  border-width: 0 5px 5px 0;
  display: inline-block;
  padding: 25px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  position: absolute;
  right: 0;
  top: 3px;
  z-index: 1;
  pointer-events: none;
}

.job-group__jobride:last-child:after {
  border: solid #F2F2F2;
  border-width: 0 25px 25px 0;
  padding: 10px;
  right: -22px;
  top: 9px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/plan/JobGroup.vue